import { IBusLocation } from "@/domain/entities/lineInfo";
import { ITurnBusLastSeatCount } from "@/types";
import { computed, Ref } from "vue";

export const useTurnBusLastSeatCountList = (
  busLocations: Ref<IBusLocation[]>
) => {
  const turnBusLastSeatCountList = computed<ITurnBusLastSeatCount[]>(() =>
    getTurnBusLastSeatCountList(busLocations.value)
  );

  const getTurnBusLastSeatCountList = (busLocations: IBusLocation[]) => {
    const busOrderLastSeatCounts = [];

    for (const location of busLocations) {
      busOrderLastSeatCounts.push({
        allocUid: location.allocUid,
        remainSeatCount: location.remainingSeatsCount,
        boardingCount: location.boardingCount,
      });
    }

    return busOrderLastSeatCounts;
  };

  return { turnBusLastSeatCountList };
};
